import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, ChangeDetectorRef } from '@angular/core';
import {  NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { isType53Checklist, isType53DocumentRequired, type53FileValidators } from './type53-docs.util';
import { Type22Service } from '@services/services/type22.service';
import { TimeAlert } from '../pop-up/activity-alert/activity-alert.component';
import { Router } from '@angular/router';
import { type14NestedSearchable as resolveType14NestedSearchable } from '../app-tree-select/type14-tree.util';
import { digitsMaxLengthFromPattern, isMobilePePattern } from '../customfields-input/customfields-input.util';

export interface Field {
  actionid: null,
  alias: string,
  allowedit: boolean,
  attachmentid: null,
  category: boolean | null,
  customfieldsgroupid: number,
  format: boolean | null,
  formula: string | null,
  groupname: string,
  groupstatusid: number,
  hidden: boolean | null,
  readonly: boolean | null,
  disabled: boolean | null,
  id: number,
  name: string,
  regularexpression: string | null,
  required: boolean,
  requirementactionlogid: number | null,
  showwhenediting: boolean,
  type: number,
  validationmessage: null,
  value: string | null | any,
  values: any | null,
  warning: null,
  conditional: any,
  data: any
}

export interface Active {
  id: string,
  value: boolean
}

@Component({
    selector: 'app-custom-fields-switch',
    templateUrl: './custom-fields-switch.component.html',
    styleUrls: ['./custom-fields-switch.component.scss'],
    standalone: false
})
export class CustomFieldsSwitchComponent implements OnInit, OnChanges {
  @Input() public field: any;
  @Input() public subtype: string[];
  @Input() public formCustomFields: FormGroup;
  @Input() public isDisabledDateSla: boolean;
  @Input() public fieldIsNotEmpty: { [name: string]: boolean };
  @Input() public options1: any;
  @Input() public context: string;
  @Input() public isEditing: boolean;

  @Input() public nestedValues: [];
  @Input() public counterTree: [];

  @Input() public setSelectValue: number;
  @Input() edit: boolean = false;
  @Input() flagActionLog: boolean = false;
  @Input() copySourceOptions: { index: number; label: string }[] | null = null;
  @Input() copyAllowOther = false;
  @Input() copyOtherLabel = 'Otro';
  @Input() copyOtherValue = 'otro';
  @Input() copyIndexFieldId: number | string | null = null;
  /** Fila tipo 48: false si el interruptor de copiar está apagado. null fuera de esa fila. */
  @Input() copyLocksActive: boolean | null = null;
  /** Cambia al copiar ubigeo para volver a armar Provincia/Distrito. */
  @Input() type14RefreshToken: number | null = null;

  isRadioChoices(field: any): boolean {
    let deps = field?.fielddependencies;
    if (deps == null || deps === '') return false;
    if (typeof deps === 'string') {
      try {
        deps = JSON.parse(deps);
      } catch {
        return false;
      }
    }
    return deps?.choices === 'radio';
  }

  // Cache para el FormArray de documentos del tipo 53
  documentosArrayCache: { [fieldId: number]: FormArray } = {};

  @Output() public onChangeChild = new EventEmitter<object>();
  @Output() public formatearRutChild = new EventEmitter<object>();
  @Output() public rutKeyupChild = new EventEmitter<any>();
  @Output() public onCheckboxChangeChild = new EventEmitter<object>();
  @Output() public onCheckRadioChangeChild = new EventEmitter<object>();
  @Output() public removeInputChild = new EventEmitter<any>();
  @Output() public addInputChild = new EventEmitter<object>();
  @Output() public addDataChild = new EventEmitter<object>();
  @Output() public onValueChangeChild = new EventEmitter<object>();
  @Output() public removeDataChild = new EventEmitter<object>();
  @Output() public deleteItemChild = new EventEmitter<object>();
  @Output() public compareSelectSimpleWithInputTextChild = new EventEmitter<object>();
  @Output() public getItem24ValuesChild = new EventEmitter<object>();
  @Output() public getItem22ValuesChild = new EventEmitter<object>();
  @Output() public addInputToArrayChild = new EventEmitter<any>();
  @Output() public onValueChange26Child = new EventEmitter<object>();
  @Output() public removeItemRepeaterChild = new EventEmitter<object>();
  @Output() public addItemRepeaterChild = new EventEmitter<object>();
  @Output() public findItemSelectChild = new EventEmitter<object>();
  @Output() public onValueChange50Child = new EventEmitter<any>();
  @Output() public addItemChild = new EventEmitter<any>();
  @Output() public parseSubTypeChild = new EventEmitter<object>();
  typePlazo: number = 0;

  itemSelected = 0;
  /** Id departamento tipo 14 (local: el @Input setSelectValue lo pisa el padre). */
  type14DepartamentoId: string = '';
  nextName: string = ""

  // Type 55 state
  type55Sub1Items: any[] = [];
  type55Sub1Label: string = '';
  type55Sub2Items: any[] = [];
  type55Sub2Label: string = '';

  year: number = 0;
  month: number = 0;
  day: number = 0;

  fieldSelected: any;
  searchForm;
  materia: any;
  timeActivity: TimeAlert = {
    hour: 8,
    minute: 32,
    second: 0
  }

  meridian = true;
  rucRequiered:boolean=false;
  public activos: Array<Active> = [];
  baseUrl: string;

  // Propiedades para el autocomplete
  filteredOptions: string[] = [];
  selectedOptionIndex: number = -1;
  showOptions: boolean = false;

  constructor(private fb: FormBuilder, private type22: Type22Service, private router: Router,
  private modalService: NgbModal, private cdr: ChangeDetectorRef) {
    this.searchForm = this.fb.group({
      search: '',
    });
  }

  ngOnInit() {
    if (this.field.type === 22) this.type22.customOption.subscribe(type => this.typePlazo = type)

    if (this.field.type === 10) {
      if (this.edit) {
        this.materia = [...this.field.value]
      } else {
        this.materia = [...this.field.values]
      }
    }
    this.setAppTree()
    this.nowDate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.field?.type === 14 && changes['type14RefreshToken'] && !changes['type14RefreshToken'].firstChange) {
      this.setAppTree();
    }
  }

  /**
   * Select simple (tipo 5): valor del <option> siempre string (evita [object Object] si values trae objetos).
   * Objetos con `name` se tratan como en tipo 6.
   */
  selectSimpleOptionValue(opt: any): string {
    if (opt === null || opt === undefined) return '';
    const t = typeof opt;
    if (t === 'string' || t === 'number' || t === 'boolean') return String(opt);
    if (t === 'object' && !Array.isArray(opt)) {
      if (opt.name != null) return String(opt.name);
      if (opt.label != null) return String(opt.label);
    }
    return '';
  }

  selectSimpleOptionLabel(opt: any): string {
    const v = this.selectSimpleOptionValue(opt);
    if (v) return v;
    if (opt && typeof opt === 'object' && !Array.isArray(opt) && opt.tooltip != null) {
      return String(opt.tooltip);
    }
    return '';
  }

  /** Visibilidad: conditional.whenSet o igualdad legacy customfieldvalue. */
  fieldVisible(field: any): boolean {
    const c = field?.conditional;
    if (!c || !this.formCustomFields) {
      return true;
    }
    const parentId = c.customfieldid;
    if (parentId == null) {
      return true;
    }
    const parentVal = this.formCustomFields.controls[parentId]?.value;
    if (c.whenSet) {
      return parentVal != null && parentVal !== '' && parentVal !== 'null';
    }
    if (c.customfieldvalue !== undefined && c.customfieldvalue !== null) {
      return String(parentVal) === String(c.customfieldvalue);
    }
    return true;
  }

  nowDate() {
    let fecha = new Date();
    this.day = fecha.getDate();
    this.month = fecha.getMonth() + 1;
    this.year = fecha.getFullYear();
  }

  onChange(e?, fields?) {
    if(fields && fields.name=='Tipo identificación'){
      this.rucRequiered=true;
    }
    this.onChangeChild.emit({ e, fields });
  }

  /** Sincroniza fecha escrita a mano en el input (dateSelect solo dispara al elegir en el calendario). */
  onDateBlur(event: FocusEvent, field: any) {
    const inputValue = (event.target as HTMLInputElement)?.value?.trim();
    if (!inputValue || !field) {
      return;
    }
    this.onChange(inputValue, field);
  }

  isCopyLocked(field: any): boolean {
    if (this.copyLocksActive === false) return false;
    const ctrl = this.formCustomFields?.controls?.[field?.id];
    return !!(ctrl as any)?.copyLocked;
  }

  /** El selector de representante solo se ve si el interruptor está encendido. */
  showCopySourceSelect(): boolean {
    if (this.copyLocksActive === false) return false;
    if (this.field && Number(this.field.type) === 4) {
      const raw = this.formCustomFields?.controls?.[this.field.id]?.value;
      return raw === true || raw === 'true' || raw === 1 || raw === '1';
    }
    return true;
  }

  onCopySourceIndexChange(event: Event, field: any) {
    const value = (event.target as HTMLSelectElement)?.value;
    this.onChange({ target: { value, copySourceIndex: true } }, field);
  }

  onType6Change(event: Event, field: any) {
    const ctrl = this.formCustomFields?.controls?.[field?.id];
    if (ctrl && (ctrl as any).copyLocked) {
      const previous = (ctrl as any)._copyLockValue;
      ctrl.setValue(previous != null ? previous : ctrl.value, { emitEvent: false });
      const target = event.target;
      if (target instanceof HTMLSelectElement) {
        target.value = ctrl.value ?? '';
      }
      return;
    }
    this.onChange(event, field);
  }

  onCheckboxChangeType4(event: any, field: any) {
    // Convertir el valor del checkbox a boolean antes de actualizar el formulario
    const checked = event.target.checked;
    // Actualizar el valor del formulario directamente con boolean
    this.formCustomFields.controls[field.id].setValue(checked, { emitEvent: false });
    // Emitir el cambio con el valor convertido - asegurarse de pasar field correctamente
    // Usar checked en lugar de value para checkboxes
    if (field) {
      this.onChange({ target: { value: checked, checked: checked } }, field);
    }
  }

  onToggleSwitchChange(event: any, field: any) {
    // Convertir el valor del toggle switch a boolean
    const checked = event.target.checked;

    // Actualizar el valor del formulario directamente con boolean
    this.formCustomFields.controls[field.id].setValue(checked, { emitEvent: false });

    // Emitir el cambio con el valor convertido
    // onChange espera dos parámetros: e y fields
    if (field) {
      const e = { target: { value: checked, checked: checked } };
      this.onChange(e, field);
    } else {
      console.warn('⚠️ Field is null or undefined');
    }
  }

  onValueChangeSearch(term, field) {
    if (this.edit) {
      field.value = this.filtrado(this.materia, term)
    } else {
      field.values = this.filtrado(this.materia, term)
    }

  }

  filtrado(arr, term = null) {
    if (!term) {
      return this.setState(arr);
    } else {
      let filtered = arr.filter(item => item.name.toLowerCase().includes(term.toLowerCase()));
      return this.setState(filtered);
    }
  }

  setState(arrayF) {
    return arrayF.map(itemm => {
      let find = null;
      find = this.activos.find((item) => item.id == itemm.name)
      if (find) {
        itemm['value'] = find.value
      }
      return itemm;
    });
  }

  formatearRut(event, field?, key?) {
    // Si el campo tiene skipFormatting o noFormat, no formatear
    if (field && (field.skipFormatting || field.noFormat)) {
      // No formatear, solo emitir el evento
      this.formatearRutChild.emit({ event, key, field });
      return;
    }

    // Si el campo está dentro de una agrupación (tipo 48), formatear directamente usando el formCustomFields recibido
    // que será el FormGroup correcto (repeatForm)
    if (field && field.type === 8) {
      const formattedRut = this.formatRut(event.target.value);
      if (field.type === 13 || field.type === 12) {
        // Para campos tipo 12 y 13 (múltiples RUTs)
        this.formCustomFields.controls[field.id]["controls"][key].patchValue({
          [field.id]: { values: formattedRut }
        });
      } else {
        // Para campo tipo 8 (RUT simple)
        this.formCustomFields.patchValue({
          [field.id]: formattedRut
        });
      }
    }
    // También emitir el evento para mantener compatibilidad
    this.formatearRutChild.emit({ event, key, field });
  }

  formatRut(rut) {
    if (rut && rut.length > 7) {
      const rev = rut
        .replace(/[\.-]+/g, "")
        .split("")
        .reverse()
        .join("");
      const formated =
        rev.substr(0, 1) +
        "-" +
        rev.substr(1, 3) +
        "." +
        rev.substr(4, 3) +
        "." +
        rev.substr(7, 2);
      formated.split("").reverse().join("");
      rut = formated.split("").reverse().join("");
    }
    return rut;
  }
  rutKeyup(e) {
    this.rutKeyupChild.emit(e);
  }
  onCheckboxChange(e, index) {
    this.setActive(e.target.value, e.target.checked)
    this.onCheckboxChangeChild.emit({ e, index });
  }
  setActive(id, value) {
    let findIndex = this.activos.findIndex((item) => item.id == id)
    if (findIndex < 0) {
      this.activos.push({ id: id, value: value })
    } else {
      this.activos[findIndex] = { id: id, value: value }
    }
  }
  onCheckRadioChange(e, index, type) {
    this.onCheckRadioChangeChild.emit({ e, index, type });
  }
  removeInput(i: number, id) {
    this.removeInputChild.emit({ i, id });
  }
  addInput(id, type) {
    this.addInputChild.emit({ id, type });
  }
  addData(field, val) {
    this.addDataChild.emit({ field, val });
  }
  onValueChange(event, name: string, index: number) {
    this.onValueChangeChild.emit({ event, name, index });
  }
  removeData(i, fieldId) {
    this.removeDataChild.emit({ i, fieldId });
  }
  deleteItem(id: number, index: number) {
    this.deleteItemChild.emit({ id, index });
  }
  compareSelectSimpleWithInputText(o1: any, o2: any) {
    this.compareSelectSimpleWithInputTextChild.emit({ o1, o2 });
  }
  getItem24Values(event, name: string) {
    this.getItem24ValuesChild.emit({ event, name });
  }
  getItem22Values(event, name: string) {
    this.getItem22ValuesChild.emit({ event, name });
  }
  addInputToArray(fieldId) {
    this.addInputToArrayChild.emit(fieldId);
  }
  onValueChange26(event, field: any, index: number) {
    this.onValueChange26Child.emit({ event, field, index });
  }
  removeItemRepeater(field, id) {
    this.removeItemRepeaterChild.emit({ field, id });
  }
  addItemRepeater(field) {
    this.addItemRepeaterChild.emit(field);
  }
  findItemSelect(field) {
    this.findItemSelectChild.emit(field);
  }
  onValueChange50(id_ciudad: number) {
    this.onValueChange50Child.emit(id_ciudad);
  }
  addItem(id: number) {
    this.addItemChild.emit(id);
  }
  parseSubType(e?, fields?) {
    this.parseSubTypeChild.emit({ e, fields });
  }

  getOrder(list) {

    var mapped = list.map(function (el, i) {
      return { index: i, value: el.toLowerCase() };
    })

    // ordenando el array mapeado que contiene los valores reducidos
    mapped.sort(function (a, b) {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });

    // contenedor para el orden resultante
    var result = mapped.map(function (el) {
      return list[el.index];
    });

    return result;
  }

  setItemSelected(idSelected) {
    this.type14DepartamentoId = idSelected != null && idSelected !== '' ? String(idSelected) : '';
    this.setSelectValue = idSelected as any;
  }

  onChangeType55(selectedId: string, field: any) {
    const customField = this.formCustomFields.controls[field.id] as FormArray;
    const formgroup = customField.controls[0] as FormGroup;
    const subArray = formgroup.get('sub') as FormArray;
    const sub2Array = formgroup.get('sub2') as FormArray;

    // Clear previous sub controls
    while (subArray.length) subArray.removeAt(0);
    while (sub2Array.length) sub2Array.removeAt(0);
    this.type55Sub1Items = [];
    this.type55Sub2Items = [];
    this.type55Sub1Label = '';
    this.type55Sub2Label = '';

    if (!selectedId || !field.values) {
      this.cdr.detectChanges();
      return;
    }

    const selected = field.values.find((v: any) => String(v.id) === String(selectedId));
    if (!selected) {
      this.cdr.detectChanges();
      return;
    }

    console.log('🟠 Type55 selected:', selected.name);
    console.log('🟠 sub:', selected.sub, 'sub2:', selected.sub2);

    // Sub1 (CECO)
    const sub1Items = selected.sub || [];
    if (sub1Items.length > 0) {
      const autoVal = sub1Items.length === 1 ? String(sub1Items[0].id) : '';
      subArray.push(this.fb.group({ seleccion1: [autoVal] }));
      console.log('🟠 Sub1 pushed, autoVal:', autoVal);
    }
    this.type55Sub1Label = selected.nameSub || '';
    this.type55Sub1Items = sub1Items;

    // Sub2 (Responsable)
    const sub2Items = selected.sub2 || [];
    if (sub2Items.length > 0) {
      const autoVal2 = sub2Items.length === 1 ? String(sub2Items[0].id) : '';
      sub2Array.push(this.fb.group({ seleccion2_1: [autoVal2] }));
      console.log('🟠 Sub2 pushed, autoVal2:', autoVal2);
    }
    this.type55Sub2Label = selected.nameSub2 || '';
    this.type55Sub2Items = sub2Items;

    console.log('🟠 type55Sub1Items:', this.type55Sub1Items.length, 'type55Sub2Items:', this.type55Sub2Items.length);
    console.log('🟠 subArray length:', subArray.length, 'sub2Array length:', sub2Array.length);

    this.cdr.detectChanges();
    this.onChange(null, field);
  }

  type14NestedSearchable(field: any): boolean {
    return resolveType14NestedSearchable(field);
  }

  fieldMaxLength(field: any): number | null {
    const re = String(field?.regularexpression || '');
    // Solo-digitos acotado (^[0-9]{1,N}$ / ^[0-9]{N}$), p.ej. RUC PE (11), DNI (8).
    const digitsMax = digitsMaxLengthFromPattern(re);
    if (digitsMax !== null) return digitsMax;
    // Pasaporte PE: 1 letra + 8 números
    if (re === '^[A-Za-z][0-9]{8}$') return 9;
    // Celular PE BF: 9 fijo + 8 dígitos del usuario
    if (isMobilePePattern(re)) return 9;
    return null;
  }

  setAppTree() {
    // Type 55 initialization
    if (this.field.type == 55) {
      this.initType55FromSelected();
    }
    if (this.field.type == 14 && this.field.selected?.length) {
      this.fieldSelected = [...this.field.selected];
      const customField = (
        this.formCustomFields?.controls?.[this.field.id]
        ?? this.formCustomFields?.controls?.[String(this.field.id)]
      ) as FormArray;
      const formgroup = customField?.controls?.[0] as FormGroup;
      if (!formgroup) {
        return;
      }
      const subForm = formgroup.get('sub') as FormArray;

      const country = this.fieldSelected.find((e) => e.nivel === 1);
      const region = this.fieldSelected.find((e) => e.nivel === 2);
      const comuna = this.fieldSelected.find((e) => e.nivel === 3);

      if (country) {
        const depId = String(country.seleccion);
        formgroup.get('seleccion')?.setValue(depId, { emitEvent: false });
        this.setItemSelected(depId);
      }
      if (region && subForm) {
        while (subForm.length < 1) {
          subForm.push(this.fb.group({ seleccion1: [''] }));
        }
        (subForm.at(0) as FormGroup)?.get('seleccion1')?.setValue(String(region.seleccion), { emitEvent: false });
        this.nextName = region.nameSub;
      }
      if (comuna && subForm) {
        while (subForm.length < 2) {
          const key = subForm.length === 0 ? 'seleccion1' : 'seleccion2';
          subForm.push(this.fb.group({ [key]: [''] }));
        }
        (subForm.at(1) as FormGroup)?.get('seleccion2')?.setValue(String(comuna.seleccion), { emitEvent: false });
      }
      this.cdr.detectChanges();
    }
  }

  formatTimeEdit(time) {
    const dateTime = time.split(':');
    return {
      hour: Number(dateTime[0]),
      minute: Number(dateTime[1]),
      second: Number(dateTime[2]),
    };
  }

  // Métodos para el autocomplete
  onAutocompleteInput(event: any, field: any) {
    const searchTerm = event.target.value.toLowerCase();

    if (field.values && Array.isArray(field.values)) {
      this.filteredOptions = field.values.filter((option: string) =>
        option.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredOptions = [];
    }

    this.selectedOptionIndex = -1;
    this.showOptions = true;

    // Emitir el cambio para mantener la funcionalidad existente
    this.onChange(event, field);
  }

  showAutocompleteOptions(field: any) {
    if (field.values && Array.isArray(field.values)) {
      this.filteredOptions = [...field.values];
      this.showOptions = true;
      this.selectedOptionIndex = -1;
    }
  }

  hideAutocompleteOptions(field: any) {
    // Usar setTimeout para permitir que el click en las opciones se ejecute primero
    setTimeout(() => {
      this.showOptions = false;
      this.selectedOptionIndex = -1;
    }, 200);
  }

  selectOption(option: string, field: any) {
    // Establecer el valor en el formulario
    this.formCustomFields.controls[field.id].setValue(option);

    // Ocultar las opciones
    this.showOptions = false;
    this.selectedOptionIndex = -1;

    // Emitir el cambio para mantener la funcionalidad existente
    this.onChange({ target: { value: option } }, field);
  }

  // Métodos para el tipo 53 (Select tipo empresa con documentos y archivos)
  getTipoEmpresaOptions(field: any): any[] {
    const parseOptions = (rawValue: any): any[] => {
      let values = rawValue;

      if (typeof values === 'string' && values.includes('[')) {
        try {
          values = JSON.parse(values);
        } catch {
          return [];
        }
      }

      if (!Array.isArray(values)) {
        return [];
      }

      return values.filter((empresa: any) => empresa && empresa.id !== undefined && empresa.id !== null);
    };

    let options = parseOptions(field?.values);

    if (!options.length) {
      options = parseOptions(field?.value);
    }

    if (options.length && field) {
      field.values = options;
    }

    return options;
  }

  onTipoEmpresaChange(event: any, field: any) {

    const tipoEmpresaId = event.target.value;
    const fieldGroup = this.formCustomFields.controls[field.id] as FormGroup;

    // Buscar el tipo de empresa seleccionado
    let nuevosDocumentos = [];
    const tipoEmpresaOptions = this.getTipoEmpresaOptions(field);
    if (tipoEmpresaOptions.length && tipoEmpresaId) {
      const tipoEmpresa = tipoEmpresaOptions.find((emp: any) => {
        // Comparar usando == para manejar string y number
        return String(emp.id) === String(tipoEmpresaId) || emp.id == tipoEmpresaId;
      });

     // console.log('🔍 Tipo de empresa encontrado:', tipoEmpresa);

      if (tipoEmpresa && tipoEmpresa.files && Array.isArray(tipoEmpresa.files)) {
        console.log('📄 Archivos encontrados:', tipoEmpresa.files);

        // Crear los nuevos FormGroups para cada documento requerido
        nuevosDocumentos = tipoEmpresa.files.map((file: any) => {
          return this.fb.group({
            fileId: [file.id],
            fileName: [file.name],
            file: [null, type53FileValidators(field, file)]
          });
        });
      }
    }

    //console.log('📋 Nuevos documentos a crear:', nuevosDocumentos.length, nuevosDocumentos);

    // PRIMERO actualizar el valor del tipo de empresa para que getTipoEmpresaSeleccionado funcione correctamente
    // Convertir a número para mantener el tipo correcto (ya que los IDs son números)
    const tipoEmpresaValue = tipoEmpresaId ? (typeof tipoEmpresaId === 'string' ? Number(tipoEmpresaId) : tipoEmpresaId) : null;
    fieldGroup.get('tipoEmpresa')?.setValue(tipoEmpresaValue, { emitEvent: false });

    // console.log('💾 Valor establecido en FormControl (ANTES de setControl):', {
      // tipoEmpresaValue: tipoEmpresaValue,
      //tipoEmpresaControlValue: fieldGroup.get('tipoEmpresa')?.value,
      //tipo: typeof fieldGroup.get('tipoEmpresa')?.value
    //});

    // LUEGO recrear completamente el FormArray para cambiar la referencia y forzar la actualización
    const nuevosDocumentosArray = this.fb.array(nuevosDocumentos);
    fieldGroup.setControl('documentos', nuevosDocumentosArray);

    // Actualizar cache
    this.documentosArrayCache[field.id] = nuevosDocumentosArray;

    // console.log('✅ FormArray actualizado. Longitud:', nuevosDocumentosArray.length);
    //console.log('📊 Estado del FormGroup:', {
      // tipoEmpresa: fieldGroup.get('tipoEmpresa')?.value,
      //  tipoEmpresaControlValue: fieldGroup.get('tipoEmpresa')?.value,
      // documentosLength: fieldGroup.get('documentos')?.value?.length
    //});

    // Forzar detección de cambios
    this.cdr.detectChanges();

    // Verificar el valor después de la detección de cambios
    //setTimeout(() => {
      //console.log('🔍 Valor después de detectChanges:', {
        // tipoEmpresa: fieldGroup.get('tipoEmpresa')?.value,
        // selectValue: event.target.value
      //});
    //}, 100);

    // Emitir el cambio DESPUÉS de actualizar el FormArray y el valor
    // Esto asegura que el valor correcto se envíe al componente padre
    this.onChange(event, field);

    //console.log('🟢 onTipoEmpresaChange - COMPLETADO');
  }

  onFileChange(event: any, field: any, index: number) {
    const file = event.target.files[0];
    if (file) {
      const fieldGroup = this.formCustomFields.controls[field.id] as FormGroup;
      const documentosArray = fieldGroup.get('documentos') as FormArray;
      const documentoGroup = documentosArray.at(index) as FormGroup;

      // Obtener el nombre original del documento desde el campo fileId
      const fileId = documentoGroup.get('fileId')?.value;
      const tipoEmpresa = this.getTipoEmpresaSeleccionado(field);
      let documentoName = '';

      if (tipoEmpresa && tipoEmpresa.files) {
        const documentoInfo = tipoEmpresa.files.find((f: any) => f.id == fileId);
        if (documentoInfo) {
          documentoName = documentoInfo.name; // Este es el nombre del documento del JSON
        }
      }

      // Guardar el nombre del documento del JSON, no el nombre del archivo
      documentoGroup.patchValue({
        file: file,
        fileName: documentoName || file.name // Usar el nombre del documento del JSON
      });

      // Actualizar el label del input file (mostrar el nombre del archivo para el usuario)
      const fileInput = document.getElementById(`file-${field.id}-${index}`) as HTMLInputElement;
      if (fileInput && fileInput.nextElementSibling) {
        (fileInput.nextElementSibling as HTMLLabelElement).textContent = file.name;
      }

      // Emitir el cambio
      this.onChange(event, field);
    }
  }

  getDocumentosArray(field: any): FormArray {
    const fieldGroup = this.formCustomFields.controls[field.id] as FormGroup;
    const documentosArray = fieldGroup.get('documentos') as FormArray;
    // Actualizar cache
    this.documentosArrayCache[field.id] = documentosArray;

    //console.log('📦 getDocumentosArray llamado - Longitud:', documentosArray?.length, 'Controles:', documentosArray?.controls?.length);

    return documentosArray;
  }

  getTipoEmpresaSeleccionado(field: any): any {
    const tipoEmpresaOptions = this.getTipoEmpresaOptions(field);
    if (!tipoEmpresaOptions.length) {
      return null;
    }
    const fieldGroup = this.formCustomFields.controls[field.id] as FormGroup;
    const tipoEmpresaId = fieldGroup.get('tipoEmpresa')?.value;

  //  ('🔎 getTipoEmpresaSeleccionado - tipoEmpresaId:', tipoEmpresaId, 'tipo:', typeof tipoEmpresaId);

    if (!tipoEmpresaId) {
      return null;
    }
    const encontrado = tipoEmpresaOptions.find((emp: any) => {
      const match = String(emp.id) === String(tipoEmpresaId) || emp.id == tipoEmpresaId;
      //('🔍 Comparando:', emp.id, 'con', tipoEmpresaId, 'match:', match);
      return match;
    });

    //('✅ Tipo empresa encontrado en getTipoEmpresaSeleccionado:', encontrado);

    return encontrado;
  }

  isDocChecklist(field: any): boolean {
    return isType53Checklist(field);
  }

  documentoObligatorio(field: any, documento: any): boolean {
    const meta = this.documentoMeta(field, documento?.get?.('fileId')?.value);
    return isType53DocumentRequired(field, meta);
  }

  archivoElegido(documento: any): string {
    const file = documento?.get?.('file')?.value;
    return file && file.name ? file.name : '';
  }

  private documentoMeta(field: any, fileId: any): any {
    const tipoEmpresa = this.getTipoEmpresaSeleccionado(field);
    if (!tipoEmpresa || !Array.isArray(tipoEmpresa.files)) {
      return null;
    }
    return tipoEmpresa.files.find((f: any) => f.id == fileId) || null;
  }

  getDocumentoName(field: any, fileId: any): string {
    const tipoEmpresa = this.getTipoEmpresaSeleccionado(field);
    if (tipoEmpresa && tipoEmpresa.files && Array.isArray(tipoEmpresa.files)) {
      const documento = tipoEmpresa.files.find((f: any) => f.id == fileId);
      return documento ? documento.name : '';
    }
    return '';
  }

  initType55FromSelected() {
    if (!this.field.values) return;
    const customField = this.formCustomFields.controls[this.field.id] as FormArray;
    const formgroup = customField.controls[0] as FormGroup;

    // If editing with a saved value
    if (this.field.value) {
      let saved = this.field.value;
      if (typeof saved === 'string') {
        try { saved = JSON.parse(saved); } catch (e) { return; }
      }
      const val = Array.isArray(saved) ? saved[0] : saved;
      if (val && val.seleccion) {
        formgroup.controls['seleccion'].setValue(String(val.seleccion));
        this.onChangeType55(String(val.seleccion), this.field);

        // Restore sub selection
        if (val.sub && val.sub.length > 0 && val.sub[0].seleccion1) {
          const subArray = formgroup.get('sub') as FormArray;
          if (subArray.length > 0) {
            (subArray.controls[0] as FormGroup).controls['seleccion1'].setValue(String(val.sub[0].seleccion1));
          }
        }
        // Restore sub2 selection
        if (val.sub2 && val.sub2.length > 0 && val.sub2[0].seleccion2_1) {
          const sub2Array = formgroup.get('sub2') as FormArray;
          if (sub2Array.length > 0) {
            (sub2Array.controls[0] as FormGroup).controls['seleccion2_1'].setValue(String(val.sub2[0].seleccion2_1));
          }
        }
      }
    }
  }

  /**
   * Redirección desde action_redirect (tipo 37, tipo 52 hijo con dependsOn, etc.).
   */
  navigateTo(path: string) {
    this.modalService.dismissAll();
    this.router.navigate([`${path}`])
  }
}
